import React from 'react';

const ImageSkeleton = () => {
  return <div>Image Skeleton</div>;
};

export default ImageSkeleton;
